import React from 'react';
import {trackPageView} from '@forwardfinancing/analytics-frontend-library';
import SubmissionsKpiData from './SubmissionsKpiData';
import LatestApprovals from './LatestApprovals';
import LatestContracts from './LatestContracts';
import LatestLeads from './LatestLeads';
import linkUtils from '../../lib/linkUtils';

class HomePage extends React.Component {
  componentDidMount() {
    trackPageView(linkUtils.getLocationName(this.props));
  }

  render() {
    return (
      <div className="home-page column page">
        <div className="header">Performance Dashboard</div>
        <div className="home-page__content-kpi page">
          <SubmissionsKpiData />
        </div>
        <div className="home-page__content-contracts page">
          <LatestContracts />
        </div>
        <div className="home-page__content-approvals page">
          <LatestApprovals />
        </div>
        <div className="home-page__content-leads page">
          <LatestLeads />
        </div>
      </div>
    );
  }
}

export default HomePage;
